import Route from "@ember/routing/route"

export default class DatesRoute extends Route {
  queryParams = {
    date: { refreshModel: true },
  }

  afterModel() {
    this.replaceWith("planbook.show.planner", {
      queryParams: { perspective: "week" },
    })
  }
}
